(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-text-section"] && !Shopify.designMode) return;
  try {
    
  // Load Flickity library
  if (!window.Flickity) {
    var flickityScript = document.createElement('script');
    flickityScript.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
    flickityScript.onload = initializeMarqueeSliders;
    document.head.appendChild(flickityScript);
  } else {
    initializeMarqueeSliders();
  }

  function initializeMarqueeSliders() {
    // Initialize Flickity for marquee effect - target only marquee sections
    document.addEventListener('DOMContentLoaded', function() {
      var marqueeElements = document.querySelectorAll('.marquee-section .marquee-content');
      
      marqueeElements.forEach(function(elem) {
        if (elem.getAttribute('data-flickity')) {
          var options = JSON.parse(elem.getAttribute('data-flickity'));
          
          // Enhanced options for ultra-smooth marquee effect
          options.freeScroll = true;
          options.contain = false;
          options.groupCells = false;
          options.friction = 0.1;
          options.selectedAttraction = 0.005;
          options.dragThreshold = 3;
          options.freeScrollFriction = 0.001;
          options.cellAlign = 'left';
          options.percentPosition = false;
          options.setGallerySize = false;
          
          // Initialize Flickity
          var flkty = new Flickity(elem, options);
          
          // Custom smooth continuous scroll
          var isPaused = false;
          
          function continuousScroll() {
            if (!isPaused && flkty.player.isPlaying) {
              var progress = flkty.player.tick / flkty.options.autoPlay;
              var moveDistance = 1; // pixels to move per frame
              
              if (options.rightToLeft) {
                flkty.x += moveDistance;
              } else {
                flkty.x -= moveDistance;
              }
              
              flkty.settle(flkty.x);
            }
            requestAnimationFrame(continuousScroll);
          }
          
          // Start continuous scroll
          requestAnimationFrame(continuousScroll);
          
          // Handle pause on hover if enabled. FIXED 2026-08-19: this used to
          // be wrapped in Liquid {% if %} tags, but Shopify does NOT render
          // Liquid inside {% javascript %} - the raw tags shipped into
          // compiled_assets/scripts.js and the resulting SyntaxError
          // ("Unexpected token '%'") killed this whole bundle on every page.
          // The setting now rides a data attribute on the markup instead.
          if (elem.getAttribute('data-pause-on-hover') === 'true') {
            elem.addEventListener('mouseenter', function() {
              isPaused = true;
              flkty.pausePlayer();
            });

            elem.addEventListener('mouseleave', function() {
              isPaused = false;
              flkty.unpausePlayer();
            });
          }
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
